module.exports = __webpack_public_path__ + "img/header-bg_s.4740fc51.png";